import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useImpersonation } from '@/hooks/useImpersonation';
import { Alert, AlertDescription } from '@/components/ui/alert';

export function ImpersonationBanner() {
  const { isImpersonating, targetUser, endImpersonation } = useImpersonation();

  if (!isImpersonating || !targetUser) {
    return null;
  }

  return (
    <Alert className="rounded-none border-x-0 border-t-0 bg-amber-50 border-amber-200 py-2">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5 text-amber-600" />
          <AlertDescription className="text-sm font-medium text-amber-900 m-0">
            <span className="font-semibold">Impersonation Mode Active:</span> You are currently viewing as{' '}
            <span className="font-semibold">{targetUser.displayName}</span> ({targetUser.companyName})
          </AlertDescription>
        </div>
        <Button
          onClick={endImpersonation}
          variant="outline"
          size="sm"
          className="bg-white hover:bg-amber-100 border-amber-300 text-amber-900"
        >
          <X className="h-4 w-4 mr-1" />
          Exit Impersonation
        </Button>
      </div>
    </Alert>
  );
}
